import { motion } from "framer-motion"
import React from "react"
import { connect } from "react-redux"
import EnquiryFeatures from "./EnquiryFeatures"
import EnquiryForm from "./EnquiryForm"
import EnquiryGallery from "./EnquiryGallery"
import * as styles from "./SupplierSignupEnquiry.module.scss"
import * as actions from "@store/actions"
import Button from "@components/objects/Button/Button"
import SiteWrapper from "@components/structure/SiteWrapper/SiteWrapper"
import signOutIcon from "@images/icons/signOut.svg"
import HowSupplierWorks from "@components/layouts/becomeSupplier/HowSupplierWorks/HowSupplierWorks";


const SupplierSignupEnquiry = ({ userAttributes, isAuthenticated, howSupplierWorks, data, signOut, referralId }) => (
  <motion.div className={styles.SupplierSignupEnquiry} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}>
    <section className={styles.header}>
      <SiteWrapper className={styles.inner}>
        <div className={styles.text}>
          <h1>{data.title}</h1>
          <p>{data.intro}</p>
        </div>
        <div className={styles.form}>
          {isAuthenticated && (
            <div className={styles.signout}>
              <label>Sign up with new details?</label>
              <Button
                text="Sign out"
                image={signOutIcon}
                design="text"
                color="white"
                size="menu"
                onClick={() => signOut(false)}
              />
            </div>
          )}
          <EnquiryForm
            userAttributes={userAttributes}
            stage={isAuthenticated ? "existing" : "new"}
            referralId={referralId}
          />
        </div>
      </SiteWrapper>
    </section>
    <HowSupplierWorks {...howSupplierWorks} />
    <EnquiryGallery gallery={data.gallery} />
  </motion.div>
)

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  userAttributes: state.auth.userAttributes,
})

const mapDispatchToProps = (dispatch) => ({
  signOut: (nav) => dispatch(actions.signOut(nav)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SupplierSignupEnquiry)
